import React, { useEffect } from 'react';
import Modal from '@mui/material/Modal';
// import { appInsights, reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from '../jsonEditorStyles';
import cn from 'clsx';
import { TextComponent } from '../../uiComponents';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Typography } from '@mui/material';
// import { sendAIAnalyticsTrace } from '../utils';

const styles1 = makeStyles((theme: Theme) =>
  createStyles({
    alignItems: {
      alignItems: 'flex-start',
    },
    baseAlign: {
      alignItems: 'baseline',
    },
    centerAlign: {
      alignItems: 'center',
    },
    justifyCentre: {
      justifyContent: 'center',
      marginTop: 20,
    },
    submitButton: {
      marginLeft: 20,
    },
    divider: {
      borderBottom: '1px solid grey',
      marginLeft: 10,
      marginRight: 10,
      flex: 1,
    },
    templatesList: {
      width: '100%',
    },
    mt30: {
      marginTop: 30,
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    heading: {
      fontSize: '1.2rem',
      lineHeight: 1.5,
    },
  }),
);
interface PromptEmailProps {
  closeComponent: any;
}

const PromptEmail = ({ closeComponent }: PromptEmailProps) => {
  const classes: any = jsonEditorStyles();
  const classes1 = styles1();
  const [doNotRemind, setDoNotRemind] = React.useState<boolean>(false);
  const [email, setEmail] = React.useState<string>(localStorage.getItem('userEmailId') || '');

  return (
    <Modal
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      open
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          console.log('Email Id to contact :', email);
          closeComponent(doNotRemind);
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className={classes.modalStyle}
    >
      <div className={classes.smallPopup}>
        <div className={cn(classes.flexCol, classes.policyBody)}>
          <div className={cn(classes1.flexRow, classes1.heading)}>
            This is a restricted sandbox environment. Please schedule a call to get a demo and understand the
            capabilities.
          </div>
          <div className={cn(classes1.flexRow, classes1.justifyCentre)}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                window.open(
                  'https://calendly.com/gritiam/demo-of-visual-authentication-journey-builder-clone',
                  '_blank',
                );
              }}
            >
              Schedule call for a demo
            </Button>
          </div>
          <div className={cn(classes1.flexRow, classes1.centerAlign)}>
            <div className={classes1.divider}></div>
            <div> or </div>
            <div className={classes1.divider}></div>
          </div>
          <br />
          <div className={cn(classes1.flexRow, classes1.justifyCentre)}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                window.open('https://www.gritiam.com/pricing.html');
              }}
            >
              View pricing options
            </Button>
          </div>
        </div>
        <div className={cn(classes1.flexRow, classes1.centerAlign)}>
          <div className={classes1.divider}></div>
          <div> or </div>
          <div className={classes1.divider}></div>
        </div>
        <br />
        <div className={cn(classes1.flexRow, classes.policyBody, classes1.alignItems)}>
          <Typography variant="body1">
            Join{' '}
            <a
              href="https://join.slack.com/t/gritsoftwaresystemshq/shared_invite/zt-1kvxj8vao-wVuVE1oUyhcez2EY~UcZrA"
              target="_blank"
            >
              our Slack channel
            </a>{' '}
            and our experts will provide answers for your technical questions about Azure AD B2C XML or about CIAM
            architecture in general. There is no cost to this service.
          </Typography>
        </div>
        <div className={cn(classes1.flexRow)}>
          <FormControlLabel
            sx={{ m: 0 }}
            label=" Click here if you do not want to be reminded again."
            control={
              <Checkbox
                checked={doNotRemind}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setDoNotRemind(!doNotRemind);
                }}
              />
            }
          />
        </div>
        <footer className={cn(classes.footer, classes1.mt30)}>
          {!doNotRemind && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                console.log('Email Id to contact :', email);
                closeComponent(false);
              }}
            >
              Remind me later in 5 mins
            </Button>
          )}
          {doNotRemind && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                console.log('Email Id to contact :', email);
                closeComponent(true);
              }}
            >
              CLOSE
            </Button>
          )}
        </footer>
      </div>
    </Modal>
  );
};

// export default withAITracking(reactPlugin, PromptEmail);
export default PromptEmail;
